<template>
  <div class="align">
    <div class="grid align__item">
      <div class="register">
        <img
          class="site__logo w-36 mx-auto"
          src="@/assets/img/logo.png"
          alt="Logo"
          height="60"
        />
        <h2>NKR Group</h2>

        <form
          @submit.prevent="updatePasswordMethod()"
          class="form"
          v-if="step == 'one'"
        >
          <div class="form__field">
            <input
              name="password"
              type="password"
              autocomplete="password"
              v-model="password"
              placeholder="••••••••••••"
            />
          </div>
          <div class="form__field">
            <input
              name="password"
              type="password"
              autocomplete="password"
              v-model="passwordConfirmation"
              placeholder="••••••••••••"
            />
          </div>
          <div v-if="errorMessage">{{ errorMessage }}</div>
          <div class="form__field">
            <input
              v-if="step == 'one'"
              type="submit"
              :value="loading ? 'Loading...' : 'Update password'"
              :disabled="loading"
            />
          </div>
          <router-link
            type="button"
            :to="{ name: 'loginPage' }"
            v-if="step == 'one'"
          >
            Go to login.
          </router-link>
        </form>
        <div v-if="step == 'two'">
          <div>
            {{ errorMessage }}
          </div>
          <router-link :to="{ name: 'loginPage' }">
            Go to Login
          </router-link>
        </div>
        <!-- <p>Already have an accout? <a href="#">Log in</a></p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { isLogged } from "@/middleware/Auth.js";
import { updatePassword } from "@/api/SyncSystem.js";
export default {
  name: "loginPage",
  data() {
    return {
      password: "",
      passwordConfirmation: "",
      errorMessage: "",
      loading: false,
      step: "one"
    };
  },
  mounted() {
    // eslint-disable-next-line no-console
    if (isLogged()) {
      this.$router.replace({ name: "home" });
      return;
    }
    this.token = this.$route.params.token;
  },
  methods: {
    updatePasswordMethod() {
      if (this.password !== this.passwordConfirmation) {
        this.errorMessage = "Both passwords should match";
        return;
      }
      if (this.password.length < 5) {
        this.errorMessage = "Password length should be at least 5 characters";
        return;
      }
      this.loading = true;
      updatePassword(this.token, this.password)
        .then(res => {
          const message = `${res.data.message}`;
          this.errorMessage = message;
          this.email = "";
          this.step = "two";
        })
        .catch(e => {
          this.$toast.open({
            message: e.response.data.message,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.align {
  background-color: $LoginBaseBgcolor;
  color: $LoginBaseColor;
  height: 100%;
  align-items: center;
  display: flex;
  flex-direction: row;

  &__item {
    &--start {
      align-self: flex-start;
    }

    &--end {
      align-self: flex-end;
    }
  }
}

.site {
  &__logo {
    margin-bottom: 2rem;
  }
}

$input-placeholder-color: #7e8ba3;

input {
  border: 0;
  font: inherit;

  &::placeholder {
    color: $input-placeholder-color;
  }
}

.form {
  &__field {
    margin-bottom: 1rem;
  }

  input {
    outline: 0;
    padding: 0.5rem 1rem;

    &[type="email"],
    &[type="password"] {
      width: 100%;
    }
  }
}

$grid-max-width: 25rem;
$grid-width: 100%;

.grid {
  margin: 0 auto;
  max-width: $grid-max-width;
  width: $grid-width;
}

h2 {
  font-size: 2.75rem;
  font-weight: 100;
  margin: 0 0 1rem;
  text-transform: uppercase;
}

svg {
  height: auto;
  max-width: 100%;
  vertical-align: middle;
}

$link-color: #7e8ba3;

a {
  color: $link-color;
}

.register {
  background-color: $LoginFormBgcolor;
  box-shadow: 0 0 15px #000;
  text-align: center;
  border-radius: 7px;
  padding: 4rem 2rem;

  input {
    border: 1px solid #242c37;
    border-radius: 999px;
    background-color: transparent;
    text-align: center;
    color: $LoginBaseColor;

    &[type="email"],
    &[type="password"] {
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: 1rem 50%;
    }

    &[type="email"] {
      background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#242c37"><path d="M256.017 273.436l-205.17-170.029h410.904l-205.734 170.029zm-.034 55.462l-205.983-170.654v250.349h412v-249.94l-206.017 170.245z"/></svg>');
    }

    &[type="password"] {
      background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#242c37"><path d="M195.334 223.333h-50v-62.666c0-61.022 49.645-110.667 110.666-110.667 61.022 0 110.667 49.645 110.667 110.667v62.666h-50v-62.666c0-33.452-27.215-60.667-60.667-60.667-33.451 0-60.666 27.215-60.666 60.667v62.666zm208.666 30v208.667h-296v-208.667h296zm-121 87.667c0-14.912-12.088-27-27-27s-27 12.088-27 27c0 7.811 3.317 14.844 8.619 19.773 4.385 4.075 6.881 9.8 6.881 15.785v22.942h23v-22.941c0-5.989 2.494-11.708 6.881-15.785 5.302-4.93 8.619-11.963 8.619-19.774z"/></svg>');
    }

    &[type="submit"] {
      background-image: linear-gradient(
        160deg,
        $LoginBaseBgcolor 10%,
        $LoginBaseBgcolor 100%
      );
      color: $LoginBaseColor;
      margin-bottom: 6rem;
      width: 100%;
    }
    &[type="submit"]:hover {
      background-image: linear-gradient(
        160deg,
        $LoginBaseBgcolor 10%,
        $LoginBaseBgcolor 50%
      );
      opacity: 0.9;
    }
  }
}
</style>
